//
//
//
//
//

export default {
  name: 'form-title',
  props: {
    title: {
      type: String,
      default: ''
    },
    color: {
      type: String,
      default: '#2fb7fc'
    },
    isSwipe: {
      type: Boolean,
      default: false
    }
  }
}
